import { Autocomplete, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

DoctorTypeDropdown.propTypes = {
  doctorTypes: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default function DoctorTypeDropdown({ doctorTypes, value, onChange, isLoading }) {
  return (
    <Autocomplete
      fullWidth
      size="small"
      value={doctorTypes.length > 0 ? doctorTypes.find((type) => type.id === value) ?? null : null}
      onChange={(_, newValue) => onChange(newValue?.id ?? null)}
      options={doctorTypes}
      getOptionLabel={(option) => option?.name || ''}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      renderInput={(params) => <TextField {...params} label="Select a doctor type" autoComplete="off" />}
      loading={isLoading}
    />
  );
}
